export const adjustUnderline = () => {
	const heading = document.querySelector(".banner .txt-col h1");
	var computedStyle = window.getComputedStyle(heading);
	var words = heading.innerText.split(" ");
	var maxWidth = 0;
	var offsetLeft = 0;
	var currentLine = "";
	const extraWidth = 10;
	offsetLeft = -1 * (extraWidth / 2);

	// Measure the width of the entire text
	var fullTextWidth = measureText(heading.innerText, computedStyle.font);

	// Check if the text is single-line
	if (fullTextWidth <= heading.offsetWidth + 20) {
		maxWidth = fullTextWidth + extraWidth;
	} else {
		// Iterate through words to construct lines for multi-line text
		for (var i = 0; i < words.length; i++) {
			var testLine = currentLine + words[i] + " ";
			var testWidth = measureText(testLine, computedStyle.font);

			if (testWidth > heading.offsetWidth && i > 0) {
				maxWidth = Math.max(maxWidth, measureText(currentLine, computedStyle.font));
				currentLine = words[i] + " ";
			} else {
				currentLine = testLine;
			}
		}

		maxWidth = Math.max(maxWidth, measureText(currentLine, computedStyle.font)) + extraWidth;
	}

	// console.log(maxWidth);
	heading.style.setProperty("--underline-offset", offsetLeft + "px");
	heading.style.setProperty("--underline-width", maxWidth + "px");
	heading.style.setProperty("--underline-opacity", "1");
};

export const measureText = (text, font) => {
	// Create a canvas element
	var canvas = document.createElement("canvas");
	var context = canvas.getContext("2d");

	// Set the font to match your h1 element
	context.font = font;

	// Measure the text
	return context.measureText(text).width;
};
